export enum ClothIdAttribute {
	OBJECT = 'ClothIdAttribute_object',
}

// export enum ClothSolverAttribute {
// 	STEPS_COUNT = 'ClothSolverAttribute_stepsCount',
// }

export enum ClothSolverUniformName {
	SIZE = 'tSize',
	POSITION0 = 'tPosition0',
	POSITION1 = 'tPosition1',
	NORMAL = 'tNormal',
}

export enum ClothGeometryAttributeName {
	VISCOSITY = 'viscosity',
	SPRING = 'spring',
}
